import React from 'react'
import { Link } from '@inertiajs/react'
import { ArrowRight } from 'lucide-react'
import styles from './ReadMoreLink.module.scss'

interface ReadMoreLinkProps {
  href: string
  label: string
}

export const ReadMoreLink: React.FC<ReadMoreLinkProps> = ({ href, label }) => (
  <Link href={href} className={styles.link}>
    {label}
    <ArrowRight size={14} className={styles.arrow} />
  </Link>
)
